import axiosInstance from "global/helpers/axiosInstance";
import {
  ACTIVARTOTP_ERROR,
  ACTIVARTOTP_LOADING,
  ACTIVARTOTP_RESET,
  ACTIVARTOTP_SUCCESS,
} from "../../ActionTypes";

export const wsPostActivarTotp = (usuario, password, token) => (dispatch) => {
  dispatch({
    type: ACTIVARTOTP_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post("/activartotp", {
        usuario: usuario,
        password: password,
        token: token,
      })
      .then((res) => {
        sessionStorage.token = res.data.token;
        dispatch({
          type: ACTIVARTOTP_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: ACTIVARTOTP_ERROR,
          payload: error,
        });
      });
  });
};

export const activarTotpReset = () => (dispatch) => {
  dispatch({
    type: ACTIVARTOTP_RESET,
  });
};
